import React from "react"
import styles from "./video.module.scss"

const Video = (props) => {

  const srcString = 'https://players.brightcove.net/5813221784001/k0JxzRFET_default/index.html?videoId='+props.object.brightcoveId
  return(
    <div className={styles.videoContainer}>
      <iframe title={props.object.brightcoveId} className={styles.videoIframe} src={srcString} allowFullScreen="" allow="encrypted-media">
      </iframe>
    </div>
  )
}

export default Video



